import { NgModule } from "@angular/core";
import { CircCommonModule } from "../common";
import { MyTasksGridComponent } from "./my-tasks-grid/my-tasks-grid.component";
import { MyTasksPageComponent } from "./my-tasks-page/my-tasks-page.component";

@NgModule({
  declarations: [MyTasksGridComponent, MyTasksPageComponent],
  imports: [CircCommonModule],
  exports: []
})
export class MyTasksModule {}
